/**
 * Cómo se leen la genealogía y los DEP's: las DOS elecciones que el productor
 * hace en el micrositio (Herramientas → Micrositio → Estructura) y en el
 * asistente de PDF (paso "Estructura" de carátulas e impresión).
 *
 * Es UNA sola definición para los dos lugares (antes estaba copiada en
 * `EstructuraTab.jsx` y `GenerarPDF.jsx`, lo marcó GGA el 2026-10-15): es la
 * misma decisión sobre cómo se leen los mismos datos, y tiene que decirse igual
 * donde sea que se elija. Las claves son las que entienden el backend
 * (`configuracion_micrositio.genealogia_vista` / `deps_vista` y los servicios
 * de PDF): 'arbol' | 'tabla' y 'tabla' | 'grafico'.
 */
export const GENEALOGIA_VISTA_INFO = {
  arbol: { label: 'Árbol', desc: 'Las líneas paterna y materna como ramas, igual que hoy.' },
  tabla: { label: 'Tabla', desc: 'Padre, madre, abuelos y bisabuelos en dos columnas (paterna | materna), más fácil de leer en pantallas chicas. El padre al medio, con el abuelo arriba y la abuela abajo.' },
};

export const DEPS_VISTA_INFO = {
  tabla:   { label: 'Tabla de datos', desc: 'DEP, precisión y ranking en una tabla, como la planilla de la asociación.' },
  grafico: { label: 'Gráfico de barras', desc: 'Una barra por DEP según el percentil en la raza, con los rangos Élite / Muy alto / Alto. Es el gráfico del catálogo de genética.' },
};

export const GENEALOGIA_VISTA_DEFAULT = 'arbol';
export const DEPS_VISTA_DEFAULT = 'tabla';

/** Lo que eligió el productor para el micrositio, saneado; vale como arranque del asistente. */
export const vistasDeConfig = (config) => ({
  genealogia: config?.genealogia_vista === 'tabla' ? 'tabla' : GENEALOGIA_VISTA_DEFAULT,
  deps: config?.deps_vista === 'grafico' ? 'grafico' : DEPS_VISTA_DEFAULT,
});
